import { render, staticRenderFns } from "./design_goods_menu.vue?vue&type=template&id=c08f1dd4&scoped=true"
import script from "./design_goods_menu.vue?vue&type=script&lang=js"
export * from "./design_goods_menu.vue?vue&type=script&lang=js"
import style0 from "./design_goods_menu.vue?vue&type=style&index=0&id=c08f1dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08f1dd4",
  null
  
)

export default component.exports